export const fontSize = 12;
